import { ref, getDownloadURL } from "firebase/storage";
import { storage } from '../pages/firebase';
import { getDownLoadFile } from "../apis/api";
import { AUTHEN, REGISTER_MODE } from "../models/common/common";
import { BC_Api_Create_Update_Member_Request, CustomerData } from "../models/customer";
import moment from "moment";
import { CSSProperties } from "react";

//AVCDAMOSHI.002  21/03/2025  Add code for  Adding reuse function
export function updateState<T>(state: Partial<T>, callback: React.Dispatch<React.SetStateAction<T>>) : void {
    callback((prevState : T) => ({
        ...prevState,
        ...state,
    }));
}

export async function dowloadFile( path: string ): Promise<any | undefined> {
    try {
        const storageReference = ref(storage, path);
        const url =  await getDownloadURL(storageReference);
        const response = await getDownLoadFile(url);
        const data = await response.json();
        return data;
    } catch (error : any) {
        switch (error.code) {
            case 'storage/object-not-found':
              break;
            case 'storage/unauthorized':
              break;
            case 'storage/canceled':
              break;
            case 'storage/unknown':
              break;
          }
        return;
    }
}

export async function getImageUrl(path: string): Promise<string> {
    try {
        const storageReference = ref(storage, path);
        const url =  await getDownloadURL(storageReference);
        return url;
    } catch (error) {
        console.log(error);
        return "";
    }
}

export const paramsValidation = (mode?: string, value?: string) => {
    try {
        const paramIsEmpty = !mode;
        const paramIsValid = mode === REGISTER_MODE.QR || mode === REGISTER_MODE.PHONE;
        const paramInvalid = !paramIsValid;
        if (paramIsEmpty || paramInvalid) {
            throw new Error("Please register before this page");
        }

        const isQRMode = mode === REGISTER_MODE.QR;
        const isNotExistReceiptNo = !value;
        if(isQRMode && isNotExistReceiptNo) {
            throw new Error("Receipt number must be provided");
        }
    } catch (error) {
        throw error;
    }
}

export const checkRegisterModeQR = ( mode?: string, value?: string ) => {
    try {
        const isQRMode = mode === REGISTER_MODE.QR;
        if(!isQRMode) {
            throw new Error("Please register before this page");
        }

        if (isQRMode && !value) {
            throw new Error("Receipt must be provide");
        }

    } catch (error) {
        throw error;
    }
}

export const checkRegisterModePhone = (mode?:string) => {
    try {
        const isPhoneMode = mode === REGISTER_MODE.PHONE;
        if(!isPhoneMode) {
            throw new Error("You don't have permission");
        }
    } catch (error) {
        throw error;
    }
}


export const authenticate = (username: string, password: string) => {
    const token = username + ":" + password;
    const hash = btoa(token);
    return AUTHEN.BASIC + " " + hash;
}

export const encodeURI = (url: string | number | boolean) => {
    const encoded = encodeURIComponent(url);
    return encoded;
}

export const checkConsent = (consent: string | boolean) => {
    return consent === "Yes" ? consent ? true: false : consent === "No" ? false : "";
}

export const mapCustomerCreateUpdate = (customer: CustomerData, updaet: Partial<BC_Api_Create_Update_Member_Request>, type: "UPDATE" | "CREATE" = "UPDATE") => {
    const body : BC_Api_Create_Update_Member_Request = {
        memberAccountNo: customer.bc_account_no,
        clubCode: customer.club_code,
        schemeCode: customer.scheme_code,
        mobileNo: customer.mobile_phone_no,
        lineUserId: customer.line_user_id,
        firstName: customer.first_name,
        lastName: customer.last_name,
        dateOfBirth: customer.date_of_birth,
        sex: customer.sex,
        citizenID: customer.id_card_no,
        emailAddress: customer.email_address,
        address1: customer.address,
        address2: customer.address2,
        city: customer.city,
        county: customer.country,
        postCode: customer.post_code,
        consent1: (String(customer.consent1)==="")?"":(customer.consent1===true)?"Yes":"No",
        dateConsent1: customer.consent1_date,
        consent2: (String(customer.consent1)==="")?"":(customer.consent1===true)?"Yes":"No",
        dateConsent2: customer.consent2_date,
        consent3: (String(customer.consent1)==="")?"":(customer.consent1===true)?"Yes":"No",
        dateConsent3: customer.consent3_date,
        consent4: (String(customer.consent1)==="")?"":(customer.consent1===true)?"Yes":"No",
        dateConsent4: customer.consent4_date,
        consent5: (String(customer.consent1)==="")?"":(customer.consent1===true)?"Yes":"No",
        dateConsent5: customer.consent5_date,
        consent6: (String(customer.consent1)==="")?"":(customer.consent1===true)?"Yes":"No",
        dateConsent6: customer.consent6_date,
        apiStoreRegister: customer.apistoreRegister,
        blocked: false,
        dateBlocked: "0001-01-01",
        apiType: type,
        ...updaet
    }
    return body;
}


export const formatDateTime = (date: string, time?: string) => {
    return moment(date).format("DD/MM/YYYY");
}


export const formatNumber = (format: string, value: number) => {
    return Intl.NumberFormat(format).format(value);
}

export const fontSizeToViewport = (size: string): CSSProperties => {
    const trimmed = size.trim();
    if (!trimmed.endsWith("px")) return {};

    const px = Number(trimmed.replace("px", ""));
    if (isNaN(px) || px <= 0) return {};

    return {
        fontSize: `min(${px}px, ${(px / 375 * 100).toFixed(4)}vw)`
    };
};
//C-AVCDAMOSHI.002  21/03/2025  Add code for  Adding reuse function